import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import {
  mdiEye,
  mdiEyeOff,
  mdiCheck,
  mdiCheckDecagram,
  mdiCheckDecagramOutline,
  mdiCancel,
  mdiClose,
  mdiCheckboxBlankOutline,
  mdiCheckboxMarked,
  mdiCloseCircle,
  mdiMenuDown,
  mdiMenu,
  mdiArrowLeft,
  mdiArrowRight,
  mdiArrowUp,
  mdiSend,
  mdiCheckboxMarkedCircleOutline,
  mdiMagnify,
  mdiViewDashboardOutline,
  mdiAccountEditOutline,
  mdiLogout,
  mdiAccount,
  mdiInformationOutline,
  mdiTextBoxSearch,
  mdiTextBoxSearchOutline,
  mdiExitToApp,
  mdiClipboardOutline,
  mdiAccountBox,
  mdiHome,
  mdiAccountCircle,
  mdiChevronUp,
  mdiChevronDown,
  mdiPlay,
  mdiRestore,
  mdiStop,
  mdiContentSave,
  mdiCloseCircleOutline,
  mdiPencil,
  mdiDelete,
  mdiCheckboxMarkedCircle,
  mdiPlus,
  mdiBagPersonal,
  mdiSortAlphabeticalAscending,
  mdiSortAlphabeticalDescending,
  mdiFolder,
  mdiFileDocumentArrowRightOutline,
  mdiFilePdfBox,
  mdiFileExcelBoxOutline,
  mdiFileWordBoxOutline,
  mdiDownload,
  mdiQuestion,
  mdiStar,
} from "@mdi/js";

//Usage '$vuetify.icons.xbox' or $xbox
const MY_ICONS = {
  // jm added
  wordIcon: mdiFileWordBoxOutline,
  excelIcon: mdiFileExcelBoxOutline,
  pdfIcon: mdiFilePdfBox,
  docIcon: mdiFileDocumentArrowRightOutline,
  folder: mdiFolder,
  sortAZ: mdiSortAlphabeticalAscending,
  sortZA: mdiSortAlphabeticalDescending,
  plus: mdiPlus,
  cancel1: mdiCloseCircleOutline,
  save: mdiContentSave,
  stop: mdiStop,
  loop: mdiRestore,
  play: mdiPlay,
  chevup: mdiChevronUp,
  chevdown: mdiChevronDown,
  person: mdiAccountCircle,
  person2: mdiBagPersonal,
  home: mdiHome,
  checkedcircle: mdiCheckboxMarkedCircle,
  /*Default List*/
  eye: mdiEye,
  eyeoff: mdiEyeOff,
  complete: mdiCheck,
  cancel: mdiCancel,
  close: mdiClose,
  delete: mdiCloseCircle, // delete (e.g. v-chip close)
  del: mdiDelete,
  clear: mdiClose,
  success: mdiCheck,
  successOutline: mdiCheckDecagramOutline,
  successBold: mdiCheckDecagram,
  info: mdiInformationOutline,
  warning: "...",
  error: "...",
  prev: "...",
  next: "...",
  checkboxOn: mdiCheckboxMarked,
  checkboxOff: mdiCheckboxBlankOutline,
  checkboxIndeterminate: "...",
  delimiter: "...", // for carousel
  sort: mdiArrowUp,
  expand: mdiMenuDown,
  menu: mdiMenu,
  subgroup: "...",
  dropdown: mdiMenuDown,
  radioOn: "...",
  radioOff: "...",
  edit: mdiPencil,
  ratingEmpty: "...",
  ratingFull: "...",
  ratingHalf: "...",
  loading: "...",
  first: "...",
  last: "...",
  unfold: "...",
  file: "...",
  /*Additional Icons*/
  arrowLeft: mdiArrowLeft,
  arrowRight: mdiArrowRight,
  send: mdiSend,
  checkboxMarkedOutline: mdiCheckboxMarkedCircleOutline,
  magnify: mdiMagnify,
  search: mdiMagnify,
  appViewDash: mdiViewDashboardOutline,
  accountEdit: mdiAccountEditOutline,
  logout: mdiLogout,
  account: mdiAccount,
  textSearch: mdiTextBoxSearch,
  textSearchOutline: mdiTextBoxSearchOutline,
  exitToApp: mdiExitToApp,
  clipboard: mdiClipboardOutline,
  dl: mdiDownload,
  help: mdiQuestion,
  star: mdiStar,
};

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    values: MY_ICONS,
  },

  theme: {
    // Set the default theme to dark
    // dark: true,
    // Set the default theme to light
    // light: true,
    dark: true,
    themes: {
      light: {
        background: "#172815",
        primary: "#283a44",
        secondary: "#C8D5B9",
        accent: "#CCB159",
        accent2: "#708e92",
        error: "#f44336",
        warning: "#ff9800",
        info: "#03a9f4",
        success: "#4caf50",
        cmpbk: "#172815",
        navbk: "#2c3e50",
        appbck: "#ffa500",
        darkcmpbk: "#21262d",
        lightergrey: "#3C4047",
        greenbtn: "#22f1bf",
      },
      dark: {
        appbck: "#ffa500",
        darkcmpbk: "#21262d",
        lightergrey: "#3C4047",
        redbtn: "#f44336",
        redbtnback: "#32282D",
        greenbtn: "#22f1bf",
        greenbtnhover: "#1FDEB0",
        greenbtnactive: "#1AB791",
        inputbck: "#464B52",
        primary: "#21262d",
        secondary: "#363C43",
      },
    },
    options: {
      customProperties: true,
    },
  },
});
